import { useQuery } from '@tanstack/react-query'
import { type FormEvent } from 'react'
import { propertiesQuery, type DevicePropertiesPage } from '../api/devices'
import { DatePicker } from '../ui/DatePicker'
import { FormActions, FormRow, HalfField } from '../ui/FormGrid'
import { Spinner } from '../ui/Spinner'
import type { ScreenProps } from './screens'

/**
 * Fila Properties - inventoree/devices/others/deviceProperties.php:
 * Brand, Serial, Previous inventory number, Acquisition, Warranty expiry.
 * Update (updateDetails) ramane in portalul de acum.
 *
 * Asezarea e cea comuna (`ui/FormGrid.tsx`): eticheta deasupra campului, doua
 * coloane de aceeasi latime. Inainte era `form-horizontal` cu eticheta la
 * stanga intr-un `<span class="color">` - pastila gri de 25px pe care o
 * deseneaza `_layout.scss` si pe care numai `od_console.css` o stinge, iar aia
 * e aprinsa doar in Settings.
 *
 * CE NU S-A SCHIMBAT: campurile, ordinea, numele lor si faptul ca butonul
 * Update nu scrie inca nimic de aici.
 */

export function DeviceProperties({ id }: ScreenProps) {
  const { data, error } = useQuery(propertiesQuery(id))
  if (error) {
    return (
      <div className="alert alert-danger" role="alert">
        Something went wrong: {error.message}
      </div>
    )
  }
  if (!data) return <Spinner />
  return <Properties page={data} />
}

function Properties({ page }: { page: DevicePropertiesPage }) {
  const keep = (ev: FormEvent) => ev.preventDefault()
  const form = page.form
  return (
    <div className="device-properties">
      <div className="notifications-box"></div>
      <header className="panel-heading sm" data-color="theme-inverse">
        <h4>
          <strong>Device</strong> properties
        </h4>
      </header>
      <div className="panel-body">
        <form className="updateDeviceDetails" method="post" onSubmit={keep}>
          <input type="hidden" name="device" value={page.device.id} />

          <FormRow>
            <HalfField label="Brand" htmlFor="dp_device_brand">
              <select id="dp_device_brand" className="form-control" name="device_brand" defaultValue={form.brandId}>
                <option>Select...</option>
                {page.brands.map((b) => (
                  <option key={b.id} value={b.id}>
                    {b.name}
                  </option>
                ))}
              </select>
            </HalfField>
            <HalfField label="Serial number" htmlFor="dp_device_serial_number">
              <input
                id="dp_device_serial_number"
                className="form-control"
                type="text"
                defaultValue={form.serial}
                name="device_serial_number"
              />
            </HalfField>
          </FormRow>

          <FormRow>
            <HalfField label="Previous inventory number" htmlFor="dp_device_inventory_number">
              <input
                id="dp_device_inventory_number"
                className="form-control"
                type="text"
                defaultValue={form.inventory}
                name="device_inventory_number"
              />
            </HalfField>
            <HalfField label="Acquisition date">
              <DatePicker
                value={form.acquisition}
                name="device_acquisition_date"
                onChange={() => undefined}
                icon="far fa-calendar-check ico"
              />
            </HalfField>
          </FormRow>

          <FormRow>
            <HalfField label="Warranty expiry date">
              <DatePicker value={form.warrantyExpiry} name="device_warranty_expiry_date" onChange={() => undefined} />
            </HalfField>
          </FormRow>

          <FormActions>
            <button type="submit" className="btn btn-theme">
              Update
            </button>
          </FormActions>
        </form>
      </div>
    </div>
  )
}
